
import { defineComponent } from 'vue'

export default defineComponent({
  data() {
    return {
      username: '',
      organizations: [],
      repositories: [],
      chart: false,
    }
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSubmit(this: any) {
      this.$router.push({
        name: 'Summary',
        query: {
          username: this.username,
          orgs: this.organizations,
          repos: this.repositories,
          chart: this.chart ? 'true' : 'false',
        },
      })
    },
    addItem(items: string[]) {
      items.unshift('')
    },
    removeItem(items: string[], index: number) {
      index > -1 && items.splice(index, 1)
    },
  },
})
